/**
 * Used to generate new footnote IDs, of the format a, b, c, ... aa, ab, ac, ...
 *
 * @param s Current value
 * @returns Next value
 */
export const nextAlpha = (s?: string): string => {
  if (!s) return 'a';

  const chars = s.toLowerCase().split('');
  let i = chars.length - 1;

  while (i >= 0) {
    if (chars[i] === 'z') {
      chars[i] = 'a';
      i--;
    } else {
      chars[i] = String.fromCharCode(chars[i].charCodeAt(0) + 1);
      return chars.join('');
    }
  }

  // we rolled over every position
  return 'a' + chars.join('');
};

/**
 * Same as {@link nextAlpha} but with uppercase letters
 */
export const nextUpperAlpha = (s?: string): string => {
  if (!s) return 'A';

  const chars = s.toUpperCase().split('');
  let i = chars.length - 1;

  while (i >= 0) {
    if (chars[i] === 'Z') {
      chars[i] = 'A';
      i--;
    } else {
      chars[i] = String.fromCharCode(chars[i].charCodeAt(0) + 1);
      return chars.join('');
    }
  }

  // we rolled over very position
  return 'A' + chars.join('');
};
